import { render } from "./Empty.vue?vue&type=template&id=7ebae7f1"
const script = {}

import exportComponent from "/builds/angeloferraro/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__